import React from 'react';
import { SvgIconProps } from '@mui/material';

import { SvgIcon } from '../svg-icon';

function RearLoading({ fill = '#222222', ...props }: SvgIconProps) {
  return (
    <SvgIcon
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="10" width="4" height="7" rx="1" fill={fill} />
      <rect x="11" y="19" width="3" height="4" rx="1" fill={fill} />
      <rect x="19" y="19" width="3" height="4" rx="1" fill={fill} />
      <rect
        x="1.5"
        y="16"
        width="2"
        height="5.54817"
        rx="1"
        transform="rotate(-30.4518 1.5 16)"
        fill={fill}
      />
      <rect
        x="3.8501"
        y="18.2476"
        width="2"
        height="4.66587"
        rx="1"
        transform="rotate(9.70086 3.8501 18.2476)"
        fill={fill}
      />
      <rect y="14" width="2" height="9" rx="1" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 8V4H22V18H11V16H9V19C9 19.5523 9.44772 20 10 20H23C23.5523 20 24 19.5523 24 19V3C24 2.44772 23.5523 2 23 2H10C9.44772 2 9 2.44772 9 3V8H11Z"
        fill={fill}
      />
      <path
        d="M2.56359 11.9041C2.08661 11.6257 1.92565 11.0134 2.20407 10.5364C2.48249 10.0594 3.09485 9.89846 3.57182 10.1769L6.63615 11.9656C7.11312 12.244 7.27408 12.8564 6.99566 13.3333C6.71724 13.8103 6.10488 13.9713 5.62791 13.6928L2.56359 11.9041Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 9C6.44772 9 6 9.44772 6 10V10.4364L7.14022 11.1019C8.09416 11.6588 8.41608 12.8835 7.85925 13.8374C7.53871 14.3866 6.99685 14.7263 6.41272 14.8095C6.57762 14.9293 6.78056 15 7 15H11C11.5523 15 12 14.5523 12 14V10C12 9.44772 11.5523 9 11 9H7ZM6 13.8207C6.38765 13.8721 6.78615 13.6922 6.99562 13.3333C7.27403 12.8563 7.11307 12.244 6.6361 11.9656L6 11.5943V13.8207Z"
        fill={fill}
      />
      <rect
        x="1.69995"
        y="11.4"
        width="2"
        height="5.54817"
        rx="1"
        transform="rotate(-59.7271 1.69995 11.4)"
        fill={fill}
      />
      <circle cx="2" cy="7" r="2" fill={fill} />
    </SvgIcon>
  );
}

export { RearLoading };
